import React from "react";
import { useTinyHost } from "@tiny/host-contract";
import { useGetSegmentBySegmentIdQuery } from "@tiny/api";
import { useRefresh } from "@tiny/components/src/RefreshProvider";
import { isPredefinedSegment } from "../../components/SegmentList/SegmentList.helpers";
import useCustomSegmentFeatures from "../../hooks/useCustomSegmentFeatures";

export function useViewSegment(segmentIdProp?: string) {
  // segmentId arrives via props from the app's route layer.
  const segmentId = segmentIdProp;

  const { navigate } = useTinyHost();

  const { showUpgradePopup, hasRightsToAccess } = useCustomSegmentFeatures();

  const [saveAsOpen, setSaveAsOpen] = React.useState(false);

  const { refresh } = useRefresh();

  const { data, isLoading } = useGetSegmentBySegmentIdQuery(segmentId!);

  const openSaveAs = React.useCallback(() => {
    if (hasRightsToAccess(true)) {
      setSaveAsOpen(true);
    } else {
      showUpgradePopup();
    }
  }, [hasRightsToAccess, showUpgradePopup]);

  const closeSaveAs = React.useCallback(() => {
    setSaveAsOpen(false);
  }, []);

  const redirectToSavedAs = React.useCallback(
    (id: string) => {
      refresh();
      navigate.replace(`/main/audience/segments/${id}`, {
        state: {
          backUrl: {
            pathname: "/main/audience",
            search: "tab=custom_segments",
          },
        },
      });
    },
    [navigate, refresh]
  );

  const initialSegmentName = data?.name;
  const filter = data?.filter;
  const isPredefined = isPredefinedSegment(data?.segmentType);
  const editDisabled = isPredefined;
  const editDisabledTooltip =
    "You can't edit a predefined segment. Please Save as first.";

  return {
    segmentId,
    initialSegmentName,
    filter,
    redirectToSavedAs,
    isLoading,
    isPredefined,
    editDisabled,
    editDisabledTooltip,
    openSaveAs,
    closeSaveAs,
    saveAsOpen,
  };
}
